import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { SmartShell } from '../../components/smart/SmartShell';
import { SMART_ROUTES } from '../../constants';

/**
 * Gallery mock of flow-smart SmsConsentPopup — Tailwind smart chrome, not lola.
 * Sits over a muted phone-capture placeholder (same moment as the live gate).
 */
export const SmsTermsPage = () => {
  const { t } = useTranslation('smart');
  const navigate = useNavigate();
  const phone = t('smsConsent.maskedNumber');

  return (
    <SmartShell title={t('smsConsent.phonePlaceholderTitle')}>
      <p className="text-fg-muted text-sm">
        {t('smsConsent.phonePlaceholderBody')}
      </p>

      <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/40">
        <section
          role="dialog"
          aria-modal="true"
          aria-label={t('smsConsent.title')}
          className="bg-bg w-full max-w-md rounded-t-2xl px-6 pt-5 pb-8"
        >
          <h2 className="text-center text-base font-semibold">
            {t('smsConsent.title')}
          </h2>
          <p className="text-fg-muted mt-3 text-center text-sm">
            {t('smsConsent.intro', { phone })}
          </p>
          <div className="mt-3 flex justify-center">
            <button
              type="button"
              className="text-accent text-sm font-semibold underline"
              onClick={() => navigate(SMART_ROUTES.SMS_TERMS_DETAIL)}
            >
              {t('smsConsent.viewPolicy')}
            </button>
          </div>
          <div className="mt-6 grid grid-cols-2 gap-2">
            <button
              type="button"
              className="border-border text-fg rounded-xl border px-4 py-3 text-sm font-semibold"
            >
              {t('smsConsent.decline')}
            </button>
            <button
              type="button"
              className="bg-accent text-accent-fg rounded-xl px-4 py-3 text-sm font-semibold"
            >
              {t('smsConsent.accept')}
            </button>
          </div>
        </section>
      </div>
    </SmartShell>
  );
};

/** Gallery mock of flow-smart SmsTermsPage (message policy detail). */
export const SmsTermsDetailPage = () => {
  const { t } = useTranslation('smart');
  const navigate = useNavigate();

  return (
    <div className="smart-root">
      <main className="bg-bg text-fg mx-auto flex min-h-dvh w-full max-w-md flex-col px-5 pt-8 pb-8">
        <header className="mb-6 flex items-center justify-between gap-3">
          <button
            type="button"
            className="text-fg-muted text-sm font-semibold"
            onClick={() => navigate(SMART_ROUTES.SMS_TERMS)}
          >
            {t('common.back')}
          </button>
          <h1 className="text-base font-semibold">
            {t('smsConsent.detailTitle')}
          </h1>
          <span className="w-10" aria-hidden />
        </header>
        <section className="text-fg-muted whitespace-pre-wrap text-sm leading-relaxed">
          {t('smsConsent.detailBody')}
        </section>
      </main>
    </div>
  );
};
